import makeStyles from '@mui/styles/makeStyles';

import { signupTokens, teal900 } from '@/theme/colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
  },
  input: {
    width: 44,
    height: 52,
    border: `1px solid ${signupTokens.borderMid}`,
    borderRadius: 4,
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 600,
    outline: 'none',
    caretColor: teal900,
    '&:focus': {
      borderColor: teal900,
      boxShadow: `0 0 0 1px ${teal900}`,
    },
    '&:disabled': {
      backgroundColor: 'var(--surfaceSecondary)',
      cursor: 'not-allowed',
    },
  },
  inputError: {
    borderColor: 'var(--errorText)',
    '&:focus': {
      borderColor: 'var(--errorText)',
      boxShadow: '0 0 0 1px var(--errorText)',
    },
  },
});
